import React, { useEffect, useState } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Checkbox } from 'primereact/checkbox';
import { classNames } from 'primereact/utils';
import { RadioButton } from 'primereact/radiobutton';
import { getConfiguredLabel } from '../../common/commonHelper';
import { adminPage, rolePermissions } from '../../common/labelConstants';

export const MultiSelectController = ({  field, fieldState, controlConfig}) => {
    const requiredSymbol = controlConfig?.rules.required.value != false ? <span style={{color:"#EF2653"}}>*</span> : ""

    return (<>
        <Accordion  activeIndex={0}>
           
            <AccordionTab header = {<React.Fragment><span>{getConfiguredLabel(adminPage,rolePermissions)}</span><span>{requiredSymbol}</span></React.Fragment>} >
              
            <div className='form_wrapper'>
                {controlConfig?.options?.map((item, index) => {
                    return <span className='col-md-6' key={index}>
                        <label htmlFor={item.val} key={item.index}>{item.name}</label>
                        <Checkbox key={index}
                            name={item.name}
                            inputId={item.name}
                            onChange={(e) =>{ 
                                let value = { ...field.value, [e.target.name]: e.target.checked }
                                if(!e.target.checked){
                                    delete value[e.target.name]
                                    if(Object.keys(value).length == 0){
                                        value = undefined
                                    }
                                }
                                field.onChange(value)
                                
                             }}
                            checked={field.value && field.value[item.name]}
                            className={classNames({ 'p-invalid': fieldState.invalid })}
                        />
                    </span>
                })}
                </div>
            </AccordionTab>
        </Accordion>
    </>)
}

export const RadioButtonController = ({ field, fieldState, controlConfig = { type: '', options:[] } }) => {

    const defaultSelection = !field.value && controlConfig?.options?.find(x => x.selected)

 useEffect(() => {
     if(!field.value && defaultSelection){
         field.onChange(defaultSelection.val)
     }
 },[])
    return <div className='radio_btn'>
        {controlConfig?.options?.map((item, index) => (<React.Fragment key={index}>
            <RadioButton id={item.key} name={field.name} value={item.val} disabled={!controlConfig.editable}
                onChange={(e) =>{ 
                    if(e.target.checked) {
                        field.onChange(e.target.value)
                    } 
                }
            }
                // checked={(field.value && field.value[item.key]) || (!field.value && item.selected)}
                checked={(field.value===item.val) || (field.value==undefined && item.selected)}
                className={classNames({ 'p-invalid': fieldState.invalid })} />
            <label htmlFor={item.key}>{item.key}</label></React.Fragment>))
        }
    </div>
}

export const InputTagController = ({ field, fieldState, controlConfig = { type: '' }, className, disabled }) => {
    const [tags, setTags] = useState( field.value || []);
    const handleKeyDown = (e) => {
        if (e.type !== "blur" && e.key !== "Tab" && (e.key !== "Enter")) return
        const value = e.target.value
        if(value.length != 0)
        e.preventDefault()
        if (!value.trim()) return
        const selectedTags =  [...tags, value]
        field.onChange(selectedTags)

        setTags(selectedTags)
        e.target.value = ''
    }


    const handleRemoveTag = (index) => {
        const deSelected  = tags.filter((item, i) => i !== index)
        setTags(deSelected)
        field.onChange(deSelected.length < 1 ? undefined : deSelected)
    }


    return (
        <div className={`tags-input-container ${className} ${disabled?"rc_inputtag_disabled":""}`} >
            {tags.map((tag, index) => (
                <div className='tag-item' key={index}>
                    <span className='text'>{tag}</span>
                    {!disabled && <span className='close' onClick={() => handleRemoveTag(index)}>&times;</span>}
                </div>
            ))}
            <input disabled={disabled} autoComplete='off' name={field.name} onKeyDown={handleKeyDown} onBlur={handleKeyDown} type="text" className='tags-input' />
        </div>
    )
}